import { createSlice } from '@reduxjs/toolkit'
import { SecurityIPAccessesServerData } from '@lk/api'

import { loadSecurityIPAccesses } from './ipAccesses.actions'

export interface SecurityIPAccessesState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  list: SecurityIPAccessesServerData
}

const initialState: SecurityIPAccessesState = {
  status: 'idle',
  error: null,
  list: [],
}

export const securityIPAccessesReducer = createSlice({
  name: 'securityUsers',
  initialState,
  reducers: {},
  extraReducers: {
    [loadSecurityIPAccesses.pending.toString()]: (state) => {
      state.status = 'loading'
      state.list = []
    },
    [loadSecurityIPAccesses.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.list = action.payload
    },
    [loadSecurityIPAccesses.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
      state.list = []
    },
  },
}).reducer
